<template>
  <MainLayout>
    <v-container class="mt-10">
      <v-row>
        <v-breadcrumbs :items="breadcrumbs">
          <template v-slot:prepend>
            <v-icon icon="$vuetify" size="small"></v-icon>
          </template>
        </v-breadcrumbs>
        <v-divider></v-divider>
      </v-row>
      <v-row>
        <v-col>
          <v-btn @click="showAddInvoiceDialog" color="primary float-right"
            >Fatura Ekle</v-btn
          >
        </v-col>
      </v-row>
      <v-dialog v-model="phoneDetailsDialog" max-width="800px">
        <v-card>
          <v-card-title>
            <span class="headline">Telefon Detayları</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="phoneForm" v-model="phoneFormValid">
              <v-row>
              
                <v-col cols="6">
                    <v-text-field
                    v-model="phoneDetails.warrantyDate"
                    label="Garanti Bitiş Tarihi"
                    type="date"
                  ></v-text-field>
                   
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="phoneDetails.imei"
                    label="IMEI"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-col>
                
                <v-col cols="12" md="4">
                    <v-select
                      v-model="phoneDetails.storage"
                      :items="[
                        { title: '4GB', id: '4' },
                        { title: '8GB', id: '8' },
                        { title: '16GB', id: '16' },
                        { title: '32GB', id: '32' },
                        { title: '64GB', id: '64' },
                        { title: '128GB', id: '128' },
                        { title: '256GB', id: '256' },
                        { title: '512GB', id: '512' },
                        { title: '1TB', id: '1024' },
                      ]"
                      item-text="title"
                      item-value="id"
                      label="Hafıza"
                      :rules="[rules.required]"
                      required
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-select
                      v-model="phoneDetails.deviceCondition"
                      :items="deviceConditions"
                      label="Cihaz Durumu"
                      item-text="title"
                      item-value="id"
                      :rules="[rules.required]"
                      required
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-select
                      v-model="phoneDetails.cosmeticCondition"
                      :items="cosmeticConditions"
                      label="Kozmetik Durumu"
                      item-text="title"
                      item-value="id"
                      :rules="[rules.required]"
                      required
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-select
                      v-model="phoneDetails.backCameraCondition"
                      :items="[
                        { title: 'Evet', id: true },
                        { title: 'Hayır', id: false },
                      ]"
                      label="Arka Kamera Çalışıyormu ?"
                      :rules="[rules.required]"
                      required
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-select
                      v-model="phoneDetails.frontCameraWorking"
                      :items="[
                        { title: 'Evet', id: true },
                        { title: 'Hayır', id: false },
                      ]"
                      label="Ön Kamera Çalışıyor mu?"
                      :rules="[rules.required]"
                      required
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-select
                      v-model="phoneDetails.faceIdWorking"
                      :items="[
                        { title: 'Evet', id: true },
                        { title: 'Hayır', id: false },
                      ]"
                      label="FaceID Çalışıyor mu?"
                      :rules="[rules.required]"
                      required
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-select
                      v-model="phoneDetails.batteryCondition"
                      :items="batteryConditions"
                      label="Batarya Durumu"
                      item-text="title"
                      item-value="id"
                      :rules="[rules.required]"
                      required
                    ></v-select>
                  </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="savePhoneDetails"
              >Kaydet</v-btn
            >
            <v-btn color="grey" text @click="phoneDetailsDialog = false"
              >İptal</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="addInvoiceDialog" max-width="1000px">
        <v-card>
          <v-card-title>
            <span class="headline">Fatura Ekle</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-row>
                <v-col cols="6" md="4">
                  <v-text-field
                    v-model="newInvoice.invoiceDate"
                    label="Fatura Tarihi"
                    type="date"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="6" md="4">
                  <v-text-field
                    v-model="newInvoice.invoiceNumber"
                    label="Fatura No"
                    :value="generateInvoiceNumber()"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-autocomplete
                    v-model="newInvoice.customerId"
                    :items="customers"
                    :loading="loading"
                    item-text="title"
                    item-value="id"
                    label="Müşteri Ara"
                    solo
                    hide-no-data
                    hide-selected
                    @input="(event) => fetchCustomers(event.target.value)"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <h3>Fatura Kalemleri</h3>
              <v-row>
                <v-col
                  v-for="(item, index) in newInvoice.items"
                  :key="index"
                  cols="12"
                >
                  <v-row>
                    <v-col cols="3">
                        <v-autocomplete
                        v-model="item.stockId"
                        :items="stocks"
                        solo
                        hide-no-data
                        hide-selected
                        @update:model-value="(value) => handleStockSelect(value, index)"
                        @update:search="(val) => fetchStocks(val)"
                        item-text="title"
                        item-value="id"
                        :return-object="false"
                        label="Stok"
                        required
                      >
                        <template v-slot:selection="{ item }">
                          {{ item.title }}
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="2">
                      <v-text-field
                        v-model="item.basePrice"
                        label="Alış Fiyatı"
                        type="number"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2">
                      <v-text-field
                        v-model="item.personalPrice"
                        label="Personel Alış Fşyatı"
                        type="number"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2">
                      <v-text-field
                        v-model="item.salePrice"
                        label="Satış Fiyatı"
                        type="number"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2">
                      <v-text-field
                        v-model="item.quantity"
                        label="Miktar"
                        type="number"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2">
                      <v-select
                        v-model="item.colorId"
                        :items="colorList"
                        label="Renk"
                        item-text="title"
                        item-value="id"
                        :rules="[rules.required]"
                        required
                      ></v-select>
                    </v-col>

                    <v-col cols="1">
                      <v-btn @click="removeItem(index)" color="red">Sil</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-btn @click="addItem" color="green"
                    >Fatura Kalemi Ekle</v-btn
                  >
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row class="mt-5">
                <v-col cols="3">
                  <v-text-field
                    v-model="newInvoice.subtotal"
                    label="Ara Toplam"
                    :value="calculateSubtotal()"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-select
                    v-model="newInvoice.currency"
                    :items="currencies"
                    label="Para Birimi"
                    required
                  ></v-select>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="newInvoice.total"
                    label="Toplam"
                    :value="calculateTotal()"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="newInvoice.discount"
                    label="İndirim"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-5">
                <v-col cols="12">
                  <v-text-field
                    v-model="newInvoice.notes"
                    label="Açıklama"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="addInvoice">Ekle</v-btn>
            <v-btn color="grey" text @click="addInvoiceDialog = false"
              >İptal</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="invoiceDetailsDialog" max-width="800px">
        <v-card>
          <v-card-title>
            <span class="headline">Fatura Detayları</span>
          </v-card-title>
          <v-card-text>
            <div v-for="(detail, index) in selectedInvoiceDetails" :key="index">
              <p>
                {{ detail.stock.name }} - {{ detail.color.name }} -
                {{ detail.stock.brand.name }} - {{ detail.stock.model.name }}
                <v-btn
                  size="30"
                  @click="barcode(remoteInvoiceID + '_' + detail.id)"
                  color="blue"
                  class="icon-size"
                  icon
                >
                  <v-icon color="white" size="20">mdi-barcode</v-icon>
                  <!-- Barkod ikonu -->
                </v-btn>
              </p>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" text @click="invoiceDetailsDialog = false"
              >Kapat</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="barcodeDialog" max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Barkodlar</span>
            <!-- Başlık -->
          </v-card-title>
          <v-card-text>
            <div v-for="(item, index) in barcodeDataList" :key="index">
              <p>{{ item.name }}</p>
              <!-- Ürün adı -->
              <svg :id="'barcode-' + item"></svg>
              <!-- Barkod için SVG -->
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green" @click="printBarcodes">Yazdır</v-btn>
            <!-- Yazdır butonu -->
            <v-btn color="grey" text @click="barcodeDialog = false"
              >Kapat</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-row>
        <v-col>
          <v-data-table
            :headers="headers"
            :items="invoiceList"
            :items-per-page="10"
            class="elevation-1"
            :loading="loading"
            :search="search"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Fatura Listesi</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  label="Ara..."
                  class="mx-4"
                  solo
                  clearable
                ></v-text-field>
              </v-toolbar>
            </template>

            <template v-slot:item="{ item }">
              <tr>
                <td class="text-start" style="width: 20%">
                  {{ item.invoice_number }}
                </td>
                <td style="width: 20%">{{ item.invoice_date }}</td>
                <td style="width: 20%">{{ item.sub_total }}</td>
                <td style="width: 20%">{{ item.total }}</td>
                <td class="text-end" style="width: 20%">
                  <v-btn
                    size="30"
                    @click="barcode(item.id)"
                    color="blue"
                    class="icon-size"
                    icon
                  >
                    <v-icon color="white" size="20">mdi-barcode</v-icon>
                    <!-- Silme ikonu -->
                  </v-btn>
                  <v-btn
                    size="30"
                    @click="deleteInvoice(item.id)"
                    color="red"
                    class="icon-size ml-3"
                    icon
                  >
                    <v-icon color="white" size="20">mdi-delete</v-icon>
                    <!-- Silme ikonu -->
                  </v-btn>
                  <v-btn
                    size="30"
                    @click="invoiceDetail(item.id)"
                    color="orange"
                    class="icon-size ml-3"
                    icon
                  >
                    <v-icon color="white" size="20">mdi-pencil</v-icon>
                    <!-- Silme ikonu -->
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </MainLayout>
</template>

<script>
//import {mapState} from 'vuex';

import mainService from "@/services/mainService";
import MainLayout from "@/layouts/MainLayout.vue";
import Swal from "sweetalert2"; // SweetAlert2'yi içe aktar
import barcodeService from "@/services/barcodeService";
import JsBarcode from "jsbarcode";
export default {
  name: "InvoiceList",
  components: {
    MainLayout,
  },
  created() {
    this.fetchInvoiceList();
    this.fetchColorList();
  },
  data() {
    return {
      breadcrumbs: [
        {
          title: "Anasayfa",
          disabled: false,
          href: "pDashboard",
        },
        {
          title: "Fatura İşlemleri",
          disabled: false,
          href: "",
        },
      ],
      phoneDetailsDialog: false,
      phoneFormValid: false,
      warrantyMenu: false,
      currentItemIndex: null,
      phoneDetails: {
        storage: null,
        warrantyDate: null,
        imei: "",
        serialNumber: "",
      },
      phoneDetailsArray: [], // Telefon detaylarını tutacak array
      pendingPhoneDetails: [], // Henüz doldurulmamış telefon detaylarını takip etmek için

      barcodeDialog: false, // Barkod modal durumu
      barcodeDataList: [], // Barkod verilerini tutacak dizi
      invoiceDetailsDialog: false, // Modal state for invoice details
      selectedInvoiceDetails: [], // Holds the details of the selected invoice
      headers: [
        {
          title: "Fatura No",
          value: "invoice_number",
        },
        {
          title: "Fatura Tarihi",
          value: "invoice_date",
        },
        {
          title: "Ara Toplam",
          value: "sub_total",
        },
        {
          title: "Toplam",
          value: "toplam",
        },
        {
          title: "İşlemler",
          value: "actions",
          sortable: false,
          align:'end'
        }, // Aksiyonlar için
      ],
      select: {
        name: "Seçiniz",
        id: "0",
      },

      
      deviceConditions: [
        { title: "Yeni", id: "1" },
        { title: "Yeni Gibi", id: "2" },
        { title: "Kötü", id: "3" },
      ],
      cosmeticConditions: [
        { title: "Yeni", id: "1" },
        { title: "Yeni Gibi", id: "2" },
        { title: "Kötü", id: "3" },
        { title: "Çizikler Var", id: "3" },
      ],
      batteryConditions: [
        { title: "İyi", id: "1" },
        { title: "Normal", id: "2" },
        { title: "Zayıf", id: "3" },
      ],


      invoiceList: [],
      loading: false, // Yükleniyor durumu
      searchInput: "", // Müşteri arama metni
      remoteInvoiceID: "", // Müşteri arama metni
      searchCustomer: null, // Müşteri arama metni
      addInvoiceDialog: false, // Kullanıcı ekleme modal durumu
      search: "",
      newInvoice: {
        invoiceDate: "",
        invoiceNumber: "",
        customerId: null,
        subtotal: 0,
        currency: "TRY",
        total: 0,
        discount: 0,
        notes: "",
        items: [
          {
            stockId: null,
            colorId: null,
            basePrice: 0,
            personalPrice: 0,
            salePrice: 0,
            quantity: 1,
          },
        ],
      },
      valid: false, // Form geçerliliği
      rules: {
        required: (value) => !!value || "Bu alan gereklidir.",
      },
      typeItems: [
        {
          text: "Müşteri",
          value: "normal",
        },
        {
          text: "Cari",
          value: "supplier",
        },
      ],
      customers: [], // Müşteri verileri
      stocks: [], // Stok verileri
      currencies: ["TRY", "USD", "EUR"], // Para birimleri
    };
  },

  methods: {
    onCustomerChange(value) {
      console.log("Seçilen müşteri ID:", value); // Seçilen müşteri ID'sini konsola yazdır
      this.newInvoice.customerId = value; // Seçilen değeri güncelle
    },
    showAddInvoiceDialog() {
      this.resetNewInvoice(); // Formu sıfırla
      this.addInvoiceDialog = true; // Modalı göster
    },

    async fetchColorList() {
      this.loading = true; // Yükleniyor durumunu başlat
      mainService
        .list("colors")
        .then((response) => {
          this.colorList = response; // Kullanıcı listesini güncelle
        })
        .catch((error) => {
          console.error("Bir hata oluştu:", error);
        })
        .finally(() => {
          this.loading = false; // Yükleniyor durumunu bitir
        });
    },
    async fetchStocks(query) {
      if (query.length < 2) {
        this.stocks = []; // Arama metni 2 karakterden azsa temizle
        return;
      }
      this.loading = true; // Yükleniyor durumunu başlat
      try {
        const response = await mainService.search(query, "stocks"); // Müşteri arama servisi

        // response kontrolü
        if (response && Array.isArray(response)) {
          this.stocks = response; // Müşteri verilerini güncelle
          console.log(this.stocks);
        } else {
          console.error("Beklenmeyen yanıt:", response);
          this.stocks = [];
          // Yanlış yanıt durumunda temizle
        }
      } catch (error) {
        console.error("Müşteri arama hatası:", error);
        this.stocks = []; // Hata durumunda temizle
      } finally {
        this.loading = false; // Yükleniyor durumunu bitir
      }
    },
    async fetchCustomers(query) {
      if (query.length < 2) {
        this.customers = []; // Arama metni 2 karakterden azsa temizle
        return;
      }
      this.loading = true; // Yükleniyor durumunu başlat
      try {
        const response = await mainService.search(query, "customers"); // Müşteri arama servisi

        // response kontrolü
        if (response && Array.isArray(response)) {
          this.customers = response; // Müşteri verilerini güncelle
          console.log(this.customers);
        } else {
          console.error("Beklenmeyen yanıt:", response);
          this.customers = [];
          // Yanlış yanıt durumunda temizle
        }
      } catch (error) {
        console.error("Müşteri arama hatası:", error);
        this.customers = []; // Hata durumunda temizle
      } finally {
        this.loading = false; // Yükleniyor durumunu bitir
      }
    },

    fetchInvoiceList() {
      this.loading = true; // Yükleniyor durumunu başlat
      mainService
        .list("invoices")
        .then((response) => {
          console.log(response);
          this.invoiceList = response; // Kullanıcı listesini güncelle
        })
        .catch((error) => {
          console.error("Bir hata oluştu:", error);
        })
        .finally(() => {
          this.loading = false; // Yükleniyor durumunu bitir
        });
    },

    async addInvoice() {
      if (this.$refs.form.validate()) {
        // Formu doğrula

        const missingDetails = this.checkMissingPhoneDetails();
        if (missingDetails.length > 0) {
          Swal.fire({
            icon: "warning",
            title: "Eksik Bilgiler",
            text: "Bazı telefon detayları eksik. Lütfen tüm telefon detaylarını doldurun.",
          });
          return;
        }

        this.newInvoice.invoiceNumber = this.generateInvoiceNumber(); // Fatura numarasını oluştur
        this.newInvoice.subtotal = this.calculateSubtotal(); // Ara toplamı hesapla
        this.newInvoice.total = this.calculateTotal(); // Toplamı hesapla
        try {
          // Fatura verilerini hazırla
          const invoiceData = {
            ...this.newInvoice,
            items: this.newInvoice.items.map((item, index) => ({
              ...item,
              phoneDetails: this.phoneDetailsArray[index] || null,
            })),
          };

          await mainService.add(invoiceData, "invoices"); // Yeni kullanıcıyı ekle
          this.fetchInvoiceList(); // Kullanıcı listesini güncelle
          this.addInvoiceDialog = false; // Modalı kapat
          this.resetNewInvoice(); // Yeni kullanıcı formunu sıfırla
        } catch (error) {
          console.error("Kullanıcı eklenirken hata oluştu:", error);
        }
      }
    },
    // Telefon detaylarını kontrol et
    checkMissingPhoneDetails() {
      return this.newInvoice.items
        .map((item, index) => ({ item, index }))
        .filter(({ item, index }) => {
          // index'i buraya ekledik
          const selectedStock = this.stocks.find((s) => s.id === item.stockId);
          return (
            selectedStock?.type === "phone" && !this.phoneDetailsArray[index]
          );
        });
    },

    // Stok seçildiğinde
    async handleStockSelect(value, index) {
      console.log("Selected Value:", value);
      console.log("Index:", index);

      const selectedStock = this.stocks.find((s) => s.id === value);
      console.log("Selected Stock:", selectedStock);

      if (selectedStock?.type === "phone") {
        console.log("Phone type detected");
        this.currentItemIndex = index;
        this.phoneDetailsDialog = true;

        // Pending listesine ekle
        if (!this.pendingPhoneDetails.includes(index)) {
          this.pendingPhoneDetails.push(index);
        }
      }

      await this.fetchStocks(value);
    },
    // Telefon detaylarını kaydet
    savePhoneDetails() {
  if (this.$refs.phoneForm.validate()) {
    // Doğrudan atama yap
    this.phoneDetailsArray[this.currentItemIndex] = { ...this.phoneDetails };

    // Pending listesinden kaldır
    const pendingIndex = this.pendingPhoneDetails.indexOf(this.currentItemIndex);
    if (pendingIndex > -1) {
      this.pendingPhoneDetails.splice(pendingIndex, 1);
    }

    // Modalı kapat ve formu temizle
    this.phoneDetailsDialog = false;
    this.resetPhoneDetailsForm();
  }
},
    // Telefon detayları formunu temizle
    resetPhoneDetailsForm() {
      this.phoneDetails = {
        storage: null,
        warrantyDate: null,
        imei: "",
        serialNumber: "",
      };
      this.currentItemIndex = null;
    },

    // Tüm formu resetle
    resetForm() {
      this.resetNewInvoice();
      this.phoneDetailsArray = [];
      this.pendingPhoneDetails = [];
    },

    async editInvoice(InvoiceId) {
      // Kullanıcı bilgilerini al
      const InvoiceToEdit = this.invoiceList.find(
        (Invoice) => Invoice.id === InvoiceId
      );
      if (InvoiceToEdit) {
        this.newInvoice = {
          ...InvoiceToEdit,
        }; // Kullanıcı bilgilerini form alanlarına doldur
        this.addInvoiceDialog = true; // Modalı aç
      }
    },

    async invoiceDetail(InvoiceId) {
      this.remoteInvoiceID = InvoiceId;
      const InvoiceToEdit = this.invoiceList.find(
        (Invoice) => Invoice.id === InvoiceId
      );
      if (InvoiceToEdit) {
        if (InvoiceToEdit.detail) {
          // detail özelliğini kontrol et
          this.selectedInvoiceDetails = {
            ...InvoiceToEdit.detail,
          };
        } else {
          console.error("Detail bilgisi mevcut değil."); // Hata mesajı
        }
        this.invoiceDetailsDialog = true; // Modalı aç
      }
    },

    async deleteInvoice(InvoiceId) {
      const { value: confirmDelete } = await Swal.fire({
        title: "Silmek istediğinize emin misiniz?",
        text: "Bu işlem geri alınamaz!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet, sil!",
        cancelButtonText: "Hayır, iptal et!",
      });

      if (confirmDelete) {
        try {
          await mainService.delete(InvoiceId, "invoices"); // Kullanıcıyı silmek için servisi çağır
          this.fetchInvoiceList(); // Kullanıcı listesini güncelle
          Swal.fire("Silindi!", "Kullanıcı başarıyla silindi.", "success");
        } catch (error) {
          console.error("Kullanıcı silinirken hata oluştu:", error);
          Swal.fire("Hata!", "Kullanıcı silinirken bir hata oluştu.", "error");
        }
      } else {
        Swal.fire(
          "İptal edildi",
          "Kullanıcı silme işlemi iptal edildi.",
          "info"
        );
      }
    },

    resetNewInvoice() {
      this.newInvoice = {
        invoiceDate: "",
        invoiceNumber: "",
        customerId: null,
        subtotal: 0,
        currency: "",
        total: 0,
        discount: 0,
        notes: "",
        items: [
          {
            stockId: null,
            colorId: null,
            basePrice: 0,
            personalPrice: 0,
            salePrice: 0,
            quantity: 1,
          },
        ],
      }; // Yeni kullanıcıyı sıfırla
    },
    generateInvoiceNumber() {
      return Math.floor(100000 + Math.random() * 900000); // Rastgele fatura numarası
    },
    calculateSubtotal() {
      return this.newInvoice.items.reduce(
        (total, item) => total + item.basePrice * item.quantity,
        0
      );
    },
    calculateTotal() {
      const subtotal = this.calculateSubtotal();
      const discount = this.newInvoice.discount ? this.newInvoice.discount : 0;
      return subtotal - discount;
    },
    addItem() {
      this.newInvoice.items.push({
        stockId: null,
        basePrice: 0,
        personalPrice: 0,
        salePrice: 0,
        quantity: 1,
      });
    },

    removeItem(itemIndex) {
      // Fatura kalemini sil
      this.newInvoice.items.splice(itemIndex, 1);

      // Telefon detaylarını sil
      this.phoneDetailsArray.splice(itemIndex, 1);

      // Pending listesinden sil
      const pendingIndex = this.pendingPhoneDetails.indexOf(itemIndex);
      if (pendingIndex > -1) {
        this.pendingPhoneDetails.splice(pendingIndex, 1);
      }

      // Kalan pending indexleri güncelle
      this.pendingPhoneDetails = this.pendingPhoneDetails.map(
        (pendingIndex) => {
          if (pendingIndex > itemIndex) {
            return pendingIndex - 1;
          }
          return pendingIndex;
        }
      );
    },

    async barcode(id) {
      // Barkod bilgilerini almak için API çağrısı yapın
      try {
        const responses = await barcodeService.getBarcodes(id); // API'den barkod bilgilerini al
        this.barcodeDataList = responses.map((response) => ({
          barcode: response.barcode,
          name: response.name,
        }));
        this.printBarcodes(); // Modalı aç
      } catch (error) {
        console.error("Barkod bilgileri alınırken hata oluştu:", error);
      }
    },
    printBarcodes() {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(
        "<html><head><title>Barkodlar</title></head><body>"
      );

      this.barcodeDataList.forEach((item) => {
        const stockName = item.stockName || "Bilinmeyen Ürün";
        const barcodeSVG = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "svg"
        );

        try {
          // Barkod SVG'sini oluştur
          JsBarcode(barcodeSVG, item.barcode, {
            format: "CODE128", // Barkod formatı (gerekirse değiştirebilirsiniz)
            lineColor: "#000",
            width: 2,
            height: 50,
            displayValue: true,
          });

          // SVG'yi HTML'e dönüştür ve ekle
          const serializer = new XMLSerializer();
          const svgString = serializer.serializeToString(barcodeSVG);

          printWindow.document.write(`<p>${stockName}</p>`);
          printWindow.document.write(svgString);

          // SVG elementini işlemden sonra temizle
          barcodeSVG.remove();
        } catch (error) {
          console.error(
            `Barkod oluşturulurken hata oluştu (${item.barcode}):`,
            error
          );
          printWindow.document.write(
            `<p>${stockName}: Barkod oluşturulamadı</p>`
          );
        }
      });

      printWindow.document.write("</body></html>");
      printWindow.document.close();

      // Yazdırma işlemini başlat
      printWindow.print();

      // Yazdırma işleminden sonra pencereyi kapat
      printWindow.onafterprint = () => {
        printWindow.close(); // Yazdırma işlemi tamamlandıktan sonra pencereyi kapat
      };
    },
  },
  mounted() {
    this.$watch("barcodeDataList", (newVal) => {
      newVal.forEach((item, index) => {
        JsBarcode(`#barcode-${index}`, item.barcode, {
          format: "CODE128", // Barkod formatı
          lineColor: "#0aa", // Çizgi rengi
          width: 2, // Çizgi genişliği
          height: 40, // Barkod yüksekliği
          displayValue: true, // Barkod numarasını göster
        });
      });
    });
  },
};
</script>

<style scoped>
/* İsteğe bağlı stil ayarları */
.v-data-table {
  background-color: #ffffff;
  /* Beyaz arka plan */
  border-radius: 8px;
  /* Köşeleri yuvarla */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  /* Hafif gölge */
}

.icon-size {
  width: 30px;
  height: 30px;
}
</style>
